// gtm.js
import TagManager from "react-gtm-module";
const gtmId = "GTM-N9R2ZK2C";

export const initializeTagManager = () => {
  TagManager.initialize({ gtmId });
};